export const LOADING = 'LOADING';
export const TOAST = 'TOAST';
export const DATA = 'DATA';
export const CLEAR_DATA = 'CLEAR_DATA';
export const FOOTER = 'FOOTER';
export const MODAL = 'MODAL';
